import { hotjar } from "react-hotjar";

import { Analytics } from "./types";

export class HotjarSourceProvider {
  initialize(hotjarClient: HotjarClient) {
    hotjar.initialize(
      hotjarClient.hotjarTrackingID,
      hotjarClient.hotjarSnippetVersion
    );

    return HotjarAnalytics();
  }
}

interface HotjarTrackerOptions {
  hotjarTrackingID: number;
  hotjarSnippetVersion: number;
  sendPageView?: boolean;
}

export interface HotjarClient extends HotjarTrackerOptions {
  provider: "hotjar";
}

export function makeHotjarClient(tracker: HotjarTrackerOptions): HotjarClient {
  return {
    provider: "hotjar",
    hotjarTrackingID: tracker.hotjarTrackingID,
    hotjarSnippetVersion: tracker.hotjarSnippetVersion,
    sendPageView: tracker.sendPageView ?? true,
  };
}

function HotjarAnalytics(): Analytics {
  return {
    group: () => {},
    register: () => {},
    identify: (userID) => {
      if (!userID) {
        return;
      }

      hotjar.identify(userID, {});
    },
    screen: () => {
      hotjar.stateChange(window.location.pathname);
    },
    ecommerceEvent: () => {},
    event: () => {},
  };
}
